<label class="control-checkbox-widget" *ngIf="type === 'checkbox'" [class.checked]="checked" [class.disabled]="disabled">
  <span class="control-checkbox-widget-label">{{ label }}</span>
  <input
    type="checkbox"
    [name]="name"
    [value]="value"
    (click)="switchValue()"
    [checked]="_checked"
    [value]="checked"
    [disabled]="disabled"
  />
  <span class="checkmark"></span>
</label>

<label class="control-toggle-widget" *ngIf="type === 'toggle'" [class.checked]="checked" [class.disabled]="disabled">
  <span class="control-checkbox-widget-label">{{ label }}</span>
  <input type="checkbox" [value]="value" (click)="switchValue()" [checked]="_checked" [value]="checked" [disabled]="disabled" />
  <span class="slider round"></span>
</label>

<div *ngIf="type === 'radio'" class="radio-as-button-widget">
  <label
    class="control-radio-widget"
    *ngFor="let item of data"
    [class.checked]="selected === (item.value ? item.value : item)"
    [class.disabled]="disabled"
  >
    <input
      [type]="type"
      (click)="emitRadioValue(item)"
      [disabled]="disabled"
      [checked]="selected === (item.value ? item.value : item)"
      [name]="name"
    />
    <p>{{ item.label ? item.label : item }}</p>
    <span class="checkmark"></span>
  </label>
</div>
